import { ReusableNotesField } from './ReusableNotesField';
import { useFormVehicleId } from 'pages/ListerVehicleUploadV2/hooks/useFormVehicleId';
import { SyncManager } from 'db';
import { InspectorCommentsInput } from 'pages/ListerVehicleUploadV2/InspectorComments';
import { useField } from 'react-final-form';

const createInspectorNotesKey = (sectionId: string, field?: string) => {
  return [sectionId, field].filter(Boolean).join('.');
};

export const FinalReviewInspectorNotes = () => {
  const id = useFormVehicleId();

  const {
    input: { value, onChange },
  } = useField(`inspector_notes.message`, { subscription: { value: true } });

  const save = async (notes: string | null, fieldName = 'notes') => {
    onChange(notes)
    const syncManager = SyncManager.getInstance(id);
    await syncManager.queueVehicleUpdate([`inspector_notes.${fieldName}`, notes]);
  };

  return <InspectorCommentsInput saveComment={save} initialValue={value} />;
  return (
    <ReusableNotesField
      autoFocus={false}
      getFieldKey={createInspectorNotesKey}
      save={save}
      sectionId={'inspector_notes'}
    />
  );
};
